import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../Moduels/Context/AuthContext";
import { hasRole } from "../rbac/access";
import BrixigoPageLoader from "./common/BrixigoPageLoader";

export default function ProtectedRoute({ children, allowedRoles }) {
  const { loading, role } = useContext(AuthContext);
  const token = localStorage.getItem("token");

  if (loading) {
    return <BrixigoPageLoader message="Loading…" />;
  }

  if (!token) return <Navigate to="/login" replace />;

  if (Array.isArray(allowedRoles) && allowedRoles.length) {
    if (!role || !hasRole(role, allowedRoles)) {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
}